export const paths = {
  base: '/',
  no_match: '*',
  bulk_invites: 'bulk-invites',
  app: 'app',
  sign_in: 'sign-in',
  sign_up: 'sign-up',
  reset_password: 'forgot-password',
  setup_password: 'set-password',
  chat: 'chat',
  questionnaire: 'questionnaire',
  preview: 'preview',
  profile: {
    root: 'profile',
    general: 'general',
    password: 'password',
    diseases: 'diseases',
    attributes: 'attributes',
    notifications: 'notifications',
    delete_account: 'delete-account',
  },
  trials: 'trials',
  trial_recruitment: 'trial-recruitment',
  trials_library: 'trials-library',
  maintenance: 'maintenance',
  questions_library: {
    root: 'questions-library',
    details: 'details',
    classification: {
      root: 'classification',
      icd_codes: 'icd-codes',
      starters: 'starters',
      tags: 'tags',
    },
    trials: 'trials',
    activity: 'activity',
    merge: 'merge',
    create: 'create',
  },
  compare: 'compare',
  create: 'create',
  criterias: 'criterias',
  volunteers: 'volunteers',
  teams: 'teams',
  collaborators: 'collaborators',
  trial_invite: 'trial-invite',
  team_trial_invite: 'team-trial-invite',
  notifications: 'notifications',
  hospitals: 'hospitals',
  diseases: 'diseases',
  request_trial: 'request-trial',
  requests: 'requests',
  b2b: 'b2b',
  team: {
    root: 'team',
    general: 'general',
    users: 'users',
    billing: 'billing',
    trials: 'trials',
  },
  create_team: 'create-team',
  onboarding: {
    root: 'onboarding',
    criteria_table: 'criteria-table',
    trial_overview: 'trial-overview',
  },
  embedded_chat: 'embedded-chat',
  embedded_chat_v2: 'embedded-chat-v2',
  users: 'users',
  ctdi: 'ctdi',
  surveys: {
    root: 'surveys',
    create: 'create',
    details: 'details',
    questions: 'questions',
    insights: 'insights',
  },
};
